import { urls } from 'Constants/Urls'
import { axiosDS } from '@pp/axios'
import { PartnerFullModel, RequestParams, ResponseCatalog } from 'Models'
import { UserModel } from 'Pages/user'
import { SimpleResponse } from 'Types/simpleResponse'
import { Id } from 'Src/types/aliases'

export const userApi = {
	getAll: async (params: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<UserModel>>(urls.user.index, { params })
		return res.data
	},
	getOne: async (id: Id) => {
		const res = await axiosDS().get<UserModel>(`${urls.user.index}/${id}`)
		return res.data
	},
	getPartner: async (id: Id) => {
		const res = await axiosDS().get<PartnerFullModel>(`${urls.partner.index}/${id}`)
		return res.data
	},
	updateOne: async (id: Id, data: UserModel) => {
		const res = await axiosDS().patch<UserModel>(`${urls.user.index}/${id}`, {
			data,
		})
		return res.data
	},
	deleteOne: async (id: Id) => {
		const res = await axiosDS().delete<SimpleResponse>(`${urls.user.index}/${id}`)
		return res.data
	},
	resendToken: async (id: Id) => {
		const res = await axiosDS().post<SimpleResponse>(`${urls.user.index}/${id}/resend_api_token`)
		return res.data
	},
	resetToken: async (id: Id) => {
		const res = await axiosDS().post<SimpleResponse>(`${urls.user.index}/${id}/reset_api_token`)
		return res.data
	},
	resetPassword: async (id: Id) => {
		const res = await axiosDS().post<SimpleResponse>(`${urls.user.index}/${id}/reset_password`)
		return res.data
	},
}
